import React, { useEffect, useState } from 'react';
import { SunIcon, MoonIcon } from 'lucide-react';
export const ThemeToggle: React.FC = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check for saved theme preference or use system preference
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });
  useEffect(() => {
    // Apply theme to document
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);
  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };
  return <button onClick={toggleTheme} className="w-9 h-9 rounded-full flex items-center justify-center text-slate-500 dark:text-[#B0C1BD] hover:bg-gray-100 dark:hover:bg-[#1A3330] transition-colors duration-200" aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-2906">
      {isDarkMode ? <SunIcon className="h-5 w-5 text-yellow-400" data-id="element-2907" /> : <MoonIcon className="h-5 w-5" data-id="element-2908" />}
    </button>;
};